import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import { get } from 'lodash'

const MY_MERCHANTS = gql`
	query GetMyMerchants {
		merchantMe {
			id
			merchants {
				id
				country
				name
				classification {
					name
					child {
						name
						child {
							name
						}
					}
				}
			}			
		}
	}
`

export const useMyMerchants = () => {
	const { data, loading } = useQuery(MY_MERCHANTS)
	const myMerchants = get(data, 'merchantMe.merchants')
	return { myMerchants, loading }
}
